import React, { ReactElement } from 'react';
import { DownloadTemplate } from '../../../components';
import Meta from '../../../components/meta';

export default function Brave(): ReactElement {
  return <DownloadTemplate platform="Brave" />;
}

// Previously inherited head content from the template's nested <Meta>.
// The Head API has no such inheritance, so this has to be explicit.
export const Head = () => <Meta />;
